import FastMarquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const WORDS = ["Culture", "Candor", "Community", "Roots", "Remembrance", "Spirit", "Tradition", "Ancestors"];

export default function Ribbon() {
  return (
    <section data-testid="marquee-ribbon" aria-hidden="true" className="overflow-hidden border-y border-[#D49A36]/15 bg-[#2D1612] py-6 md:py-8">
      <FastMarquee speed={26} gradient={false} pauseOnHover>
        {WORDS.map((word) => (
          <span key={word} className="mx-10 flex items-center gap-10 font-display text-4xl italic text-[#D49A36] md:text-6xl">
            {word}
            <Sparkles className="h-5 w-5 text-[#D49A36]/50 md:h-6 md:w-6" strokeWidth={1.5} />
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
